import * as React from "react";
import times from "lodash/times";
import { Table, TableRow, TableCell } from "./Table";
import { columnSizing } from "./JobsList";
import Placeholder from "./Placeholder";

const JobsListPlaceholder = props => {
  const renderJob = iter => {
    return (
      <TableRow key={`job-placeholder-${iter}`} columns={columnSizing}>
        <TableCell>
          <div style={{ flex: "1" }}>
            <Placeholder style={{ maxWidth: 200 }} />
            <Placeholder style={{ marginTop: 3, maxWidth: 100 }} />
          </div>
        </TableCell>
        <TableCell>
          <Placeholder style={{ maxWidth: 200 }} />
        </TableCell>
        <TableCell>
          <Placeholder style={{ maxWidth: 200 }} />
        </TableCell>
      </TableRow>
    );
  };

  return (
    <Table noSideBorders {...props}>
      <TableRow header columns={columnSizing}>
        <TableCell />
        <TableCell>Services</TableCell>
        <TableCell>Draftsman</TableCell>
      </TableRow>
      {times(15, renderJob)}
    </Table>
  );
};

export default JobsListPlaceholder;



// WEBPACK FOOTER //
// ./src/components/JobsListPlaceholder.js